import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "react-query";
import { Box, Tab, Tabs } from "@mui/material";

import { apiClient } from "api";
import { Menu } from "components/reusable/Menu";
import { PROMOTION_TYPES } from "utils/utils";
import { AppState } from "store/types";
import RadioToggleSingle from "components/RadipToggle/RadioToggleSingle";
import SellersList from "pages/Replenishment/components/SellersList";
import { clearFilters } from "store/table/table.slice";
import {
  updateSortByFilter,
  updateTextIndicatesFilter,
  updateTimeUnitFilter,
} from "store/promotionCalendar/promotionCalendar.slice";
import { addRecords } from "store/promotionCalendar/promotionCalendar.slice";

import PromotionCalendarHeader from "./PromotionCalendarHeader";
import Calendar from "./components/Calendar";
import ColorFilter from "./components/PromoTypeFilter";
import PromotionCalendarTable from "../../components/Table/PromotionCalendarTable";
import { removeAllSellers } from "store/auth/auth.slice";

function mergeEvents(events: any) {
  const mergedEvents = [];

  for (let i = 0; i < events.length; i++) {
    const currentEvent = events[i];

    if (i === 0) {
      mergedEvents.push(currentEvent);
      continue;
    }

    const previousEvent = mergedEvents[mergedEvents.length - 1];

    if (
      previousEvent.type === currentEvent.type &&
      previousEvent.promotion_id === currentEvent.promotion_id
    ) {
      previousEvent.eddate = currentEvent.eddate;
    } else {
      mergedEvents.push(currentEvent);
    }
  }

  return mergedEvents;
}

const PromotionCalendar = () => {
  const dispatch = useDispatch();
  const { promoTypeList, timeUnit, sortBy, textIndicates, seller_id } =
    useSelector((state: AppState) => state.promotionCalendar);
  const filters = useSelector((state: AppState) => state.table.columnFilters);
  const selectedSellers = useSelector(
    (state: AppState) => state.auth.selectedSellers
  );

  const [finalChartData, setFinalChartData] = useState<any>({});
  const [finalTableData, setFinalTableData] = useState<any>([]);
  const [show, setShow] = useState<boolean>(false);
  const [value, setValue] = React.useState<number>(0);
  const [columnName, setColumnName] = useState<string>("");
  const [sortType, setSortType] = useState<string>("");
  const [pageSize, setPageSize] = useState<number>(25);
  const [pageNumber, setPageNumber] = useState<number>(1);

  const getChartData = async () => {
    return await apiClient.getPromotionCalendarData(timeUnit, 40, seller_id);
  };

  const getTableData = async () => {
    return await apiClient.getPromotionCalendarTableData(
      [columnName, sortType],
      pageSize,
      filters,
      pageNumber,
      [seller_id]
    );
  };

  const {
    data: chartData,
    isFetching: isFetchingChartData,
    refetch: refetchChartData,
  } = useQuery("PromoChartData", getChartData, {
    staleTime: Infinity,
    retry: 1,
    retryDelay: 10000,
    enabled: false,
  });

  const {
    data: tableData,
    isFetching: isFetchingTableData,
    refetch: refetchTableData,
  } = useQuery("PromoTableData", getTableData, {
    staleTime: Infinity,
    retry: 1,
    retryDelay: 10000,
    enabled: false,
  });

  const getRadioValuesSingle = (values: { radio1: boolean }) => {
    if (values.radio1) {
      setShow(true);
    } else setShow(false);
  };

  const getTimeUnitValue = (timeUnitAny: string) => {
    dispatch(updateTimeUnitFilter(timeUnitAny));
  };

  const getTextIndicatesValue = (textIndicates: string) => {
    dispatch(updateTextIndicatesFilter(textIndicates));
  };

  const getSortByValue = (sortBy: string) => {
    dispatch(updateSortByFilter(sortBy));
  };

  useEffect(() => {
    dispatch(removeAllSellers());
    dispatch(clearFilters());
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const getColumnToSort = (col: string, order: string) => {
    setColumnName(col === "seller_name" ? "seller_id" : col);
    setSortType(order);
    setPageNumber(1);
  };

  const getPageNumber = (page: number) => {
    setPageNumber(page);
  };

  const getPageSize = (page: number) => {
    setPageSize(page);
    setPageNumber(1);
  };

  const isEventInPromoTypeList = (event: any) => {
    let result = false;
    promoTypeList.forEach((promoTypeItem: any) => {
      if (event.type === promoTypeItem.field && promoTypeItem.checked) {
        result = true;
        return result;
      }
    });
    return result;
  };

  useEffect(() => {
    if (timeUnit) {
      refetchChartData();
    }
  }, [timeUnit, seller_id]);
  const data = {
    data: {
      columns: [
        "2019-12-01",
        "2020-01-01",
        "2020-02-01",
        "2020-03-01",
        "2020-04-01",
        "2020-05-01",
        "2020-06-01",
        "2020-07-01",
        "2020-08-01",
        "2020-09-01",
        "2020-10-01",
        "2020-11-01",
        "2020-12-01",
        "2021-01-01",
        "2021-02-01",
        "2021-03-01",
        "2021-04-01",
        "2021-05-01",
        "2021-06-01",
        "2021-07-01",
        "2021-08-01",
        "2021-09-01",
        "2021-10-01",
        "2021-11-01",
        "2021-12-01",
        "2022-01-01",
        "2022-02-01",
        "2022-03-01",
        "2022-04-01",
        "2022-05-01",
        "2022-06-01",
        "2022-07-01",
        "2022-08-01",
        "2022-09-01",
        "2022-10-01",
        "2022-11-01",
        "2022-12-01",
        "2023-01-01",
        "2023-02-01",
        "2023-03-01",
        "2023-04-01",
        "2023-05-01",
        "2023-06-01",
        "2023-07-01",
        "2023-08-01",
        "2023-09-01",
        "2023-10-01",
        "2023-11-01",
        "2023-12-01",
        "2024-01-01",
        "2024-02-01",
        "2024-03-01",
        "2024-04-01",
        "2024-05-01",
        "2024-06-01",
        "2024-07-01",
        "2024-08-01",
        "2024-09-01",
        "2024-10-01",
        "2024-11-01",
        "2024-12-01",
        "2025-01-01",
        "2025-02-01",
        "2025-03-01",
        "2025-04-01",
        "2025-05-01",
        "2025-06-01",
        "2025-07-01",
        "2025-08-01",
        "2025-09-01",
        "2025-10-01",
        "2025-11-01",
        "2025-12-01",
        "2026-01-01",
        "2026-02-01",
        "2026-03-01",
        "2026-04-01",
        "2026-05-01",
        "2026-06-01",
        "2026-07-01",
        "2026-08-01",
        "2026-09-01",
      ],
      records: [
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B07HKNX7Q5",
          brand: "isteam",
          description:
            "iSteam Steamer for Clothes [Luxury Edition] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel [MS208 Gold]",
          DailySalesForecast: 24,
          event: [
            {
              id: "b2ebb130-372e-428d-b98d-f29d08a4b10a",
              promotion_id: "a3f004f7",
              promotion_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "CANCELED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-10-12 13:25:00",
              end_date_time: "2022-10-13 01:25:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07HKNX7Q5",
              product_name:
                "iSteam Steamer for Clothes [Luxury Edition] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel [MS208 Gold]",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 12174,
              brand: "isteam",
              start_date: "2022-10-12",
              end_date: "2022-10-13",
              date: "2022-10-01",
              eddate: "2022-11-01",
            },
            {
              id: "b741f897-1693-46f2-bd0f-facb8c95e2da",
              promotion_id: "583467ff",
              promotion_name: "Parent_Steamer",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-03-12 13:50:00",
              end_date_time: "2023-03-13 01:50:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07HKNX7Q5",
              product_name:
                "iSteam Steamer for Clothes [Luxury Edition] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel [MS208 Gold]",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 12174,
              brand: "isteam",
              start_date: "2023-03-12",
              end_date: "2023-03-13",
              date: "2023-03-01",
              eddate: "2023-04-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B07KRYQW2K",
          brand: "isteam",
          description:
            "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Blue)",
          DailySalesForecast: 19.619,
          event: [
            {
              id: "b741f897-1693-46f2-bd0f-facb8c95e2da",
              promotion_id: "583467ff",
              promotion_name: "Parent_Steamer",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-03-12 13:50:00",
              end_date_time: "2023-03-13 01:50:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07KRYQW2K",
              product_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Blue)",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 4392,
              brand: "isteam",
              start_date: "2023-03-12",
              end_date: "2023-03-13",
              date: "2023-03-01",
              eddate: "2023-04-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B08V5HWV6G",
          brand: "isteam",
          description:
            "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Charcoal Black)",
          DailySalesForecast: 15,
          event: [
            {
              id: "b2ebb130-372e-428d-b98d-f29d08a4b10a",
              promotion_id: "a3f004f7",
              promotion_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "CANCELED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-10-12 13:25:00",
              end_date_time: "2022-10-13 01:25:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B08V5HWV6G",
              product_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Charcoal Black)",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 4425,
              brand: "isteam",
              start_date: "2022-10-12",
              end_date: "2022-10-13",
              date: "2022-10-01",
              eddate: "2022-11-01",
            },
            {
              id: "005b60b2-5b99-4212-9c23-1699ca924d1f",
              promotion_id: "d894e821",
              promotion_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-11-24 19:35:00",
              end_date_time: "2022-11-25 07:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B08V5HWV6G",
              product_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Charcoal Black)",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 4425,
              brand: "isteam",
              start_date: "2022-11-24",
              end_date: "2022-11-25",
              date: "2022-11-01",
              eddate: "2022-12-01",
            },
            {
              id: "24812473-fcf6-49d8-a005-da5f8ec9e833",
              promotion_id: "a93c5066",
              promotion_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-12-02 18:00:00",
              end_date_time: "2022-12-03 06:00:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B08V5HWV6G",
              product_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Charcoal Black)",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 4425,
              brand: "isteam",
              start_date: "2022-12-02",
              end_date: "2022-12-03",
              date: "2022-12-01",
              eddate: "2023-01-01",
            },
            {
              id: "b741f897-1693-46f2-bd0f-facb8c95e2da",
              promotion_id: "583467ff",
              promotion_name: "Parent_Steamer",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-03-12 13:50:00",
              end_date_time: "2023-03-13 01:50:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B08V5HWV6G",
              product_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Charcoal Black)",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 4425,
              brand: "isteam",
              start_date: "2023-03-12",
              end_date: "2023-03-13",
              date: "2023-03-01",
              eddate: "2023-04-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B07Q4R1K3F",
          brand: "isteam",
          description:
            "iSteam Steamer for Clothes [Luxury Edition] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel [MS208 Green]",
          DailySalesForecast: 5.2222,
          event: [
            {
              id: "b2ebb130-372e-428d-b98d-f29d08a4b10a",
              promotion_id: "a3f004f7",
              promotion_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "CANCELED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-10-12 13:25:00",
              end_date_time: "2022-10-13 01:25:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07Q4R1K3F",
              product_name:
                "iSteam Steamer for Clothes [Luxury Edition] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel [MS208 Green]",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 4968,
              brand: "isteam",
              start_date: "2022-10-12",
              end_date: "2022-10-13",
              date: "2022-10-01",
              eddate: "2022-11-01",
            },
            {
              id: "005b60b2-5b99-4212-9c23-1699ca924d1f",
              promotion_id: "d894e821",
              promotion_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-11-24 19:35:00",
              end_date_time: "2022-11-25 07:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07Q4R1K3F",
              product_name:
                "iSteam Steamer for Clothes [Luxury Edition] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel [MS208 Green]",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 4968,
              brand: "isteam",
              start_date: "2022-11-24",
              end_date: "2022-11-25",
              date: "2022-11-01",
              eddate: "2022-12-01",
            },
            {
              id: "24812473-fcf6-49d8-a005-da5f8ec9e833",
              promotion_id: "a93c5066",
              promotion_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-12-02 18:00:00",
              end_date_time: "2022-12-03 06:00:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07Q4R1K3F",
              product_name:
                "iSteam Steamer for Clothes [Luxury Edition] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel [MS208 Green]",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 4968,
              brand: "isteam",
              start_date: "2022-12-02",
              end_date: "2022-12-03",
              date: "2022-12-01",
              eddate: "2023-01-01",
            },
            {
              id: "b741f897-1693-46f2-bd0f-facb8c95e2da",
              promotion_id: "583467ff",
              promotion_name: "Parent_Steamer",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-03-12 13:50:00",
              end_date_time: "2023-03-13 01:50:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07Q4R1K3F",
              product_name:
                "iSteam Steamer for Clothes [Luxury Edition] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel [MS208 Green]",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 4968,
              brand: "isteam",
              start_date: "2023-03-12",
              end_date: "2023-03-13",
              date: "2023-03-01",
              eddate: "2023-04-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B072PY74HY",
          brand: "isteam",
          description:
            "iSteam Steamer for Clothes [Home Steam Cleaner] Powerful Travel Steamer 7-in-1. Handheld Garment Steamer, Wrinkle Remover. Portable Fabric Steam Iron. Clothing Accessory for USA 110-120v [H106]",
          DailySalesForecast: null,
          event: [
            {
              id: "31914384-7c31-4f0d-bb72-82119cf1286e",
              promotion_id: "a69d7647",
              promotion_name:
                "isteam Steamer for Clothes [Home Steam Cleaner] Powerful Travel Steamer 7-in-1. Handheld Garment Steamer, Wrinkle Remover. Portable Fabric Steam Iron. Clothing Accessory for USA 110-120v [H106]",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "CANCELED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-10-11 07:15:00",
              end_date_time: "2022-10-11 19:15:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B072PY74HY",
              product_name:
                "iSteam Steamer for Clothes [Home Steam Cleaner] Powerful Travel Steamer 7-in-1. Handheld Garment Steamer, Wrinkle Remover. Portable Fabric Steam Iron. Clothing Accessory for USA 110-120v [H106]",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 1170,
              brand: "isteam",
              start_date: "2022-10-11",
              end_date: "2022-10-11",
              date: "2022-10-01",
              eddate: "2022-11-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B072PY74HY",
          brand: "isteam",
          description:
            "isteam Steamer for Clothes [Home Steam Cleaner] Powerful Travel Steamer 7-in-1. Handheld Garment Steamer, Wrinkle Remover. Portable Fabric Steam Iron. Clothing Accessory for USA 110-120v [H106]",
          DailySalesForecast: null,
          event: [
            {
              id: "d3d2d457-d4f9-4854-838b-df6a51717b9a",
              promotion_id: "d0f967ec",
              promotion_name:
                "isteam Steamer for Clothes [Home Steam Cleaner] Powerful Travel Steamer 7-in-1. Handheld Garment Steamer, Wrinkle Remover. Portable Fabric Steam Iron. Clothing Accessory for USA 110-120v [H106]",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-11-24 15:15:00",
              end_date_time: "2022-11-25 03:15:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B072PY74HY",
              product_name:
                "isteam Steamer for Clothes [Home Steam Cleaner] Powerful Travel Steamer 7-in-1. Handheld Garment Steamer, Wrinkle Remover. Portable Fabric Steam Iron. Clothing Accessory for USA 110-120v [H106]",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 1170,
              brand: "isteam",
              start_date: "2022-11-24",
              end_date: "2022-11-25",
              date: "2022-11-01",
              eddate: "2022-12-01",
            },
            {
              id: "d3761517-5581-42cd-b5b1-489b6e94357e",
              promotion_id: "66ff780e",
              promotion_name:
                "isteam Steamer for Clothes [Home Steam Cleaner] Powerful Travel Steamer 7-in-1. Handheld Garment Steamer, Wrinkle Remover. Portable Fabric Steam Iron. Clothing Accessory for USA 110-120v [H106]",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-12-03 11:35:00",
              end_date_time: "2022-12-03 23:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B072PY74HY",
              product_name:
                "isteam Steamer for Clothes [Home Steam Cleaner] Powerful Travel Steamer 7-in-1. Handheld Garment Steamer, Wrinkle Remover. Portable Fabric Steam Iron. Clothing Accessory for USA 110-120v [H106]",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 1170,
              brand: "isteam",
              start_date: "2022-12-03",
              end_date: "2022-12-03",
              date: "2022-12-01",
              eddate: "2023-01-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B07FZ537CK",
          brand: "Dryden Designs",
          description:
            "Dryden Designs Fountain Pen - Medium Nib and Fine Nib | Includes Premium Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Metallic Silver",
          DailySalesForecast: null,
          event: [
            {
              id: "6e68a71b-85cf-4f16-97a4-7029209d90ac",
              promotion_id: "37e82fc5",
              promotion_name:
                "Dryden Designs Fountain Pen - Medium and Fine Nibs | Includes Luxury Box, Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Royal Red",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-04-02 12:35:00",
              end_date_time: "2023-04-03 00:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07FZ537CK",
              product_name:
                "Dryden Designs Fountain Pen - Medium Nib and Fine Nib | Includes Premium Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Metallic Silver",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 150,
              brand: "Dryden Designs",
              start_date: "2023-04-02",
              end_date: "2023-04-03",
              date: "2023-04-01",
              eddate: "2023-05-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B07FZ58DM3",
          brand: "Dryden Designs",
          description:
            "Dryden Designs Fountain Pen - Medium and Fine Nibs | Includes Luxury Box, Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Royal Red",
          DailySalesForecast: null,
          event: [
            {
              id: "6e68a71b-85cf-4f16-97a4-7029209d90ac",
              promotion_id: "37e82fc5",
              promotion_name:
                "Dryden Designs Fountain Pen - Medium and Fine Nibs | Includes Luxury Box, Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Royal Red",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-04-02 12:35:00",
              end_date_time: "2023-04-03 00:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07FZ58DM3",
              product_name:
                "Dryden Designs Fountain Pen - Medium and Fine Nibs | Includes Luxury Box, Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Royal Red",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 151,
              brand: "Dryden Designs",
              start_date: "2023-04-02",
              end_date: "2023-04-03",
              date: "2023-04-01",
              eddate: "2023-05-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B07FZ8HQ4Y",
          brand: "Dryden Designs",
          description:
            "Dryden Designs Fountain Pen - Medium Nib amd Fine Nib | Includes Luxury Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Mysterious Blue",
          DailySalesForecast: null,
          event: [
            {
              id: "6e68a71b-85cf-4f16-97a4-7029209d90ac",
              promotion_id: "37e82fc5",
              promotion_name:
                "Dryden Designs Fountain Pen - Medium and Fine Nibs | Includes Luxury Box, Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Royal Red",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-04-02 12:35:00",
              end_date_time: "2023-04-03 00:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07FZ8HQ4Y",
              product_name:
                "Dryden Designs Fountain Pen - Medium Nib amd Fine Nib | Includes Luxury Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Mysterious Blue",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 103,
              brand: "Dryden Designs",
              start_date: "2023-04-02",
              end_date: "2023-04-03",
              date: "2023-04-01",
              eddate: "2023-05-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B07FZ8RCSZ",
          brand: "Dryden Designs",
          description:
            "Dryden Designs Fountain Pen - Medium Nib and Fine Nib | Includes Luxury Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter -Intense Black",
          DailySalesForecast: null,
          event: [
            {
              id: "6e68a71b-85cf-4f16-97a4-7029209d90ac",
              promotion_id: "37e82fc5",
              promotion_name:
                "Dryden Designs Fountain Pen - Medium and Fine Nibs | Includes Luxury Box, Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Royal Red",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-04-02 12:35:00",
              end_date_time: "2023-04-03 00:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07FZ8RCSZ",
              product_name:
                "Dryden Designs Fountain Pen - Medium Nib and Fine Nib | Includes Luxury Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter -Intense Black",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 97,
              brand: "Dryden Designs",
              start_date: "2023-04-02",
              end_date: "2023-04-03",
              date: "2023-04-01",
              eddate: "2023-05-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B07GCLGHMH",
          brand: "Dryden Designs",
          description:
            "Dryden Designs Fountain Pen - Medium Nib and Fine Nib | Includes Luxury Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter -Emerald Green",
          DailySalesForecast: null,
          event: [
            {
              id: "6e68a71b-85cf-4f16-97a4-7029209d90ac",
              promotion_id: "37e82fc5",
              promotion_name:
                "Dryden Designs Fountain Pen - Medium and Fine Nibs | Includes Luxury Box, Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Royal Red",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-04-02 12:35:00",
              end_date_time: "2023-04-03 00:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07GCLGHMH",
              product_name:
                "Dryden Designs Fountain Pen - Medium Nib and Fine Nib | Includes Luxury Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter -Emerald Green",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 44,
              brand: "Dryden Designs",
              start_date: "2023-04-02",
              end_date: "2023-04-03",
              date: "2023-04-01",
              eddate: "2023-05-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B07GCNXJX4",
          brand: "Dryden Designs",
          description:
            "Dryden Designs Fountain Pen - Medium Nib and Fine Nib | Includes Luxury Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Luscious Pink",
          DailySalesForecast: null,
          event: [
            {
              id: "6e68a71b-85cf-4f16-97a4-7029209d90ac",
              promotion_id: "37e82fc5",
              promotion_name:
                "Dryden Designs Fountain Pen - Medium and Fine Nibs | Includes Luxury Box, Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Royal Red",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-04-02 12:35:00",
              end_date_time: "2023-04-03 00:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07GCNXJX4",
              product_name:
                "Dryden Designs Fountain Pen - Medium Nib and Fine Nib | Includes Luxury Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Luscious Pink",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 102,
              brand: "Dryden Designs",
              start_date: "2023-04-02",
              end_date: "2023-04-03",
              date: "2023-04-01",
              eddate: "2023-05-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B07MFW881D",
          brand: "isteam",
          description:
            "isteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Pink)",
          DailySalesForecast: null,
          event: [
            {
              id: "b2ebb130-372e-428d-b98d-f29d08a4b10a",
              promotion_id: "a3f004f7",
              promotion_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "CANCELED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-10-12 13:25:00",
              end_date_time: "2022-10-13 01:25:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07MFW881D",
              product_name:
                "isteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Pink)",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 5065,
              brand: "isteam",
              start_date: "2022-10-12",
              end_date: "2022-10-13",
              date: "2022-10-01",
              eddate: "2022-11-01",
            },
            {
              id: "005b60b2-5b99-4212-9c23-1699ca924d1f",
              promotion_id: "d894e821",
              promotion_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-11-24 19:35:00",
              end_date_time: "2022-11-25 07:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07MFW881D",
              product_name:
                "isteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Pink)",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 5065,
              brand: "isteam",
              start_date: "2022-11-24",
              end_date: "2022-11-25",
              date: "2022-11-01",
              eddate: "2022-12-01",
            },
            {
              id: "24812473-fcf6-49d8-a005-da5f8ec9e833",
              promotion_id: "a93c5066",
              promotion_name:
                "iSteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2022-12-02 18:00:00",
              end_date_time: "2022-12-03 06:00:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07MFW881D",
              product_name:
                "isteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Pink)",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 5065,
              brand: "isteam",
              start_date: "2022-12-02",
              end_date: "2022-12-03",
              date: "2022-12-01",
              eddate: "2023-01-01",
            },
            {
              id: "b741f897-1693-46f2-bd0f-facb8c95e2da",
              promotion_id: "583467ff",
              promotion_name: "Parent_Steamer",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-03-12 13:50:00",
              end_date_time: "2023-03-13 01:50:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B07MFW881D",
              product_name:
                "isteam Steamer for Clothes [New Technology] Powerful Dry Steam. Multi-Task: Fabric Wrinkle Remover- Clean- Refresh. Handheld Clothing Accessory. for All Kind of Garments. Home/Travel (Pink)",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 5065,
              brand: "isteam",
              start_date: "2023-03-12",
              end_date: "2023-03-13",
              date: "2023-03-01",
              eddate: "2023-04-01",
            },
          ],
        },
        {
          seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
          seller_name: "Exagora",
          asin: "B08BTW8LN2",
          brand: "Dryden Designs",
          description:
            "Dryden Designs Fountain Pen - Medium Nib and Fine Nib | Includes Luxury Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Pearl White",
          DailySalesForecast: null,
          event: [
            {
              id: "6e68a71b-85cf-4f16-97a4-7029209d90ac",
              promotion_id: "37e82fc5",
              promotion_name:
                "Dryden Designs Fountain Pen - Medium and Fine Nibs | Includes Luxury Box, Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Royal Red",
              marketplace_id: "ATVPDKIKX0DER",
              type: "LIGHTNING_DEAL",
              status: "APPROVED",
              units_sold: 0,
              revenue: 0,
              start_date_time: "2023-04-02 12:35:00",
              end_date_time: "2023-04-03 00:35:00",
              seller_id: "063839e6-3d07-480d-b1aa-00626db3033b",
              asin: "B08BTW8LN2",
              product_name:
                "Dryden Designs Fountain Pen - Medium Nib and Fine Nib | Includes Luxury Box, 6 Ink Cartridges - 3 Black 3 Blue and Ink Refill Converter - Pearl White",
              product_units_sold: 0,
              product_revenue: 0,
              seller_name: "Exagora",
              total_quantity: 51,
              brand: "Dryden Designs",
              start_date: "2023-04-02",
              end_date: "2023-04-03",
              date: "2023-04-01",
              eddate: "2023-05-01",
            },
          ],
        },
      ],
    },
    errors: [],
  };
  useEffect(() => {
    if (chartData) {
      if (chartData.data && chartData.data.records) {
        const finalChartData = chartData.data.records.map((record: any) => {
          return {
            ...record,
          };
        });

        finalChartData.forEach((record: any) => {
          record.event = record.event.filter((eventItem: any) => {
            let result = false;
            if (isEventInPromoTypeList(eventItem)) {
              result = true;
              PROMOTION_TYPES.forEach((promotionType) => {
                if (promotionType.field === eventItem.type) {
                  eventItem.barColor = promotionType.color;
                }
              });
            }
            return result;
          });
          record.event = mergeEvents(record.event);
        });

        setFinalChartData(finalChartData);
      }
    }
  }, [chartData, promoTypeList]);

  useEffect(() => {
    refetchTableData();
  }, [seller_id]);

  useEffect(() => {
    if (tableData && tableData.data && tableData.data.sellers) {
      setFinalTableData(
        tableData.data.sellers.map((item: any, id: number) => ({
          ...item,
          id,
        }))
      );
      dispatch(addRecords(tableData?.total_records));
    }
  }, [tableData, filters]);

  useEffect(() => {
    if (columnName && sortType) refetchTableData();
  }, [sortType, columnName, seller_id]);

  useEffect(() => {
    if (filters?.length && filters[1].length) {
      setPageNumber(1);
    }
  }, [filters]);

  useEffect(() => {
    if (pageSize && pageNumber) refetchTableData();
  }, [columnName, sortType, pageSize, filters, pageNumber, seller_id]);

  return (
    <Box
      sx={{
        flexGrow: 1,
        minHeight: "902px",
        display: "flex",
        flexDirection: "column",
        margin: "0px 20px",
      }}
    >
      <PromotionCalendarHeader />
      <Box
        sx={{
          margin: "0px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <Box
          sx={{
            padding: "4px",
            borderRadius: "8px",
            background: "#EEEEEE",
            width: "fit-content",
            height: "fit-content",
            marginTop: "16px",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            sx={{
              "& .Mui-selected": {
                color: "white !important",
              },
              padding: "0",
              minHeight: "32px",
            }}
            TabIndicatorProps={{
              hidden: true,
            }}
          >
            <Tab
              label="CALENDAR VIEW"
              disableRipple
              wrapped={true}
              key={0}
              value={0}
              sx={{
                minHeight: "40px",
                maxHeight: "40px",
                minWidth: "155px",
                background:
                  value === 0
                    ? "linear-gradient(90deg, #044F82 0%, #2C96DE 100%)"
                    : "#EEEEEE",
                borderRadius: value === 0 ? "8px" : "8px 0 0 8px",
                color: value === 1 ? "!important" : "#757575",
                fontWeight: 600,
                borderBottom: "none",
                fontFamily: "Lato",
                fontSize: "16px",
                padding: 0,
              }}
            />
            <Tab
              label="SUMMARY VIEW"
              disableRipple
              key={1}
              value={1}
              sx={{
                minHeight: "40px",
                maxHeight: "40px",
                minWidth: "155px",
                background:
                  value === 1
                    ? "linear-gradient(90deg, #044F82 0%, #2C96DE 100%)"
                    : "#EEEEEE",
                borderRadius: value === 0 ? "0 8px 8px 0" : "8px",
                color: value === 1 ? "!important" : "#757575",
                fontWeight: 600,
                borderBottom: "none",
                fontFamily: "Lato",
                fontSize: "16px",
                padding: 0,
              }}
            />
          </Tabs>
        </Box>
        <Box>{/* <SellersList /> */}</Box>
      </Box>
      {value === 0 && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            padding: 0,
            alignItems: "baseline",
            flexDirection: "column",
            justifyContent: "end",
            margin: "15px auto 20px auto",
            flexGrow: 1,
            minHeight: 0,
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "78px",
              background: "#FFFFFF",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
              borderRadius: "8px 8px 0px 0px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", padding: "20px" }}>
              <Menu
                label="Sort By"
                val="forecasting"
                items={[
                  {
                    id: 1,
                    key: "Forecasting",
                    value: "forecasting",
                  },
                ]}
                getValue={getSortByValue}
                width="162px"
              />

              <Menu
                label="Time Unit"
                val={timeUnit}
                items={[
                  {
                    id: 1,
                    key: "Day",
                    value: "day",
                  },
                  {
                    id: 2,
                    key: "Week",
                    value: "week",
                  },
                  {
                    id: 3,
                    key: "Month",
                    value: "month",
                  },
                ]}
                getValue={getTimeUnitValue}
                width="162px"
              />

              <Menu
                label="Text Indicates"
                val="incrementalForecastedSales"
                items={[
                  {
                    id: 0,
                    key: "Promo",
                    value: "promo",
                  },
                  {
                    id: 1,
                    key: "Incremental Forecasted Sales",
                    value: "incrementalForecastedSales",
                  },
                  {
                    id: 2,
                    key: "Incremental Actual Total Sales",
                    value: "incrementalActualTotalSales",
                  },
                  {
                    id: 3,
                    key: "Total Sales Units",
                    value: "totalSalesUnits",
                  },
                  {
                    id: 4,
                    key: "Promo Attributed",
                    value: "promoAttributed",
                  },
                  {
                    id: 5,
                    key: "Promo Name",
                    value: "promoName",
                  },
                  {
                    id: 6,
                    key: "Promo Type",
                    value: "promoType",
                  },
                  {
                    id: 7,
                    key: "ASIN",
                    value: "asin",
                  },
                  {
                    id: 8,
                    key: "Description",
                    value: "description",
                  },
                  {
                    id: 9,
                    key: "Discount Level",
                    value: "discountLevel",
                  },
                ]}
                getValue={getTextIndicatesValue}
                width="223px"
              />

              <Box sx={{ position: "relative", marginLeft: "50px" }}>
                <RadioToggleSingle
                  item1="Promo Type"
                  getRadioValues={getRadioValuesSingle}
                  fromPromoCalendar={true}
                />
                {show && <ColorFilter />}
              </Box>
            </Box>
            <Box
              sx={{
                width: "300px",
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
              }}
            >
              {PROMOTION_TYPES.map((promoType, i) => {
                return (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <div
                      style={{
                        width: "16px",
                        height: "16px",
                        background: promoType.color,
                        borderRadius: "4px",
                      }}
                    ></div>
                    <span
                      style={{
                        fontFamily: "Lato",
                        fontStyle: "normal",
                        fontWeight: "400",
                        fontSize: "10px",
                        lineHeight: "12px",
                        color: "#424242",
                        marginRight: "15px",
                      }}
                    >
                      {promoType.name}
                    </span>
                  </div>
                );
              })}
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              flexGrow: 1,
              background: "#FFFFFF",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.08)",
              borderRadius: "8px 0px 0px 0px",
              display: "flex",
              minHeight: 0,
            }}
          >
            <Calendar
              isFetching={isFetchingChartData}
              data={data.data.records}
            />
          </Box>
        </Box>
      )}
      {/* Summary view */}
      {value === 1 && (
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            flexDirection: "column",
            marginTop: "40px",
            paddingBottom: "15px",
          }}
        >
          <Box
            sx={{
              position: "relative",
              borderTop: "5px solid #002B49",
              borderRadius: "8px",
              flexGrow: 1,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <PromotionCalendarTable
              rows={finalTableData}
              isCheckbox={false}
              editableRow={true}
              isGrouping={false}
              getColumnToSort={getColumnToSort}
              getPageNumber={getPageNumber}
              getPageSize={getPageSize}
              newPageNumber={pageNumber}
              newPageSize={pageSize}
              fetching={isFetchingTableData}
              columnsToSort={
                columnName && sortType ? [columnName, sortType] : []
              }
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};
export default PromotionCalendar;
